import styled from "styled-components"

const StyledInput = styled.div`
    background-color: #0e0e0e;
    height: 7rem;
    width: 98%;
    margin: .8rem auto;
    font-size: 3.2rem;
    border-radius: .4rem;
    padding: .8rem 1.6rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-family: monospace;

    input {
        width: 100%;
        background-color: #0e0e0e;
        border: 0;
        outline: none;
        text-align: end;
    }
`

export default StyledInput